var _title, _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUndo = function SvgUndo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "undo")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.36 2.64c-4.816 1.040-8.816 4.832-10.144 9.6-0.208 0.784-0.432 1.776-0.496 2.192l-0.096 0.752-4.464 0.096 3.424 4.528c1.888 2.496 3.456 4.576 3.504 4.608 0.064 0.080 6.992-8.976 6.992-9.136 0-0.048-1.008-0.080-2.24-0.080-1.536 0-2.24-0.064-2.24-0.176 0-0.512 0.576-2.256 1.008-3.104 0.64-1.232 2.32-2.912 3.552-3.552 3.28-1.712 7.104-1.216 9.776 1.28 1.968 1.824 2.832 3.808 2.832 6.432 0 2.448-0.704 4.224-2.352 5.984-1.536 1.632-3.36 2.496-5.712 2.72-1.632 0.144-2.256 0.496-2.72 1.52-0.384 0.848-0.384 1.28 0.016 2.080 0.496 1.008 0.992 1.28 2.416 1.344 4.8 0.224 9.952-3.168 12.16-8.048 1.504-3.312 1.504-7.888 0-11.2-1.808-3.984-5.472-6.976-9.616-7.84-1.408-0.288-4.192-0.288-5.6 0z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUndo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/undo.9a77360b.svg";
export { ForwardRef as ReactComponent };